































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ControlButtons extends Vue {
  @Prop({ default: false }) disabled!: boolean

  moveInterval: number | null = null

  mounted() {
    window.addEventListener('mouseup', this.stopMoving)
    window.addEventListener('touchend', this.stopMoving)
    window.addEventListener('touchcancel', this.stopMoving)
  }

  beforeDestroy() {
    window.removeEventListener('mouseup', this.stopMoving)
    window.removeEventListener('touchend', this.stopMoving)
    window.removeEventListener('touchcancel', this.stopMoving)
    this.stopMoving()
  }

  startMoving(direction: string) {
    this.stopMoving()
    this.move(direction)
    this.moveInterval = window.setInterval(() => this.move(direction), 100)
  }

  stopMoving() {
    if (this.moveInterval !== null) {
      window.clearInterval(this.moveInterval)
      this.moveInterval = null
    }
  }

  move(direction: string) {
    if (this.disabled) {
      this.stopMoving()
      return
    }
    this.$emit('move', direction)
  }
}
